export default {
  logout: {
    error: `Sorry, an error occurred logging out, please try again`,
    success: ``,
  },
};
